const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 477.63 644.77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b63f3a28-217a-4ebb-ab5f-0c767174bf24",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "fd92462f-ddd0-4005-a217-6c5907b1a8bb",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.25,70.05v437h272.5v-437Zm274.5,439H61.25v-441h276.5Z",
    style: {
      fill: "#ffc539"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.75,68.05H61.25v441h276.5ZM47.23,0H352.77A47.14,47.14,0,0,1,387,14.74q.74.78,1.44,1.59A47.12,47.12,0,0,1,400,47.23V530.77A47.28,47.28,0,0,1,352.77,578H47.23A47.28,47.28,0,0,1,0,530.77V47.23A47.29,47.29,0,0,1,47.23,0Z",
    style: {
      fill: "#ffc539"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.25,249.9s4.22,41.45,2.92,43.93,25.45,45.62,25.45,45.62l39.62-39.36s-4-52.73-1.45-55.19S153.25,249.9,153.25,249.9Z",
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.25,249.9s4.22,41.45,2.92,43.93,25.45,45.62,25.45,45.62l39.62-39.36s-4-52.73-1.45-55.19S153.25,249.9,153.25,249.9Z",
    style: {
      isolation: "isolate",
      opacity: 0.100000001490116
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 187.42,
    cy: 233,
    r: 47.63,
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,309.44l-5-2.6-24.74-21s-2.42-.82-2.57,6.7l-.14,7.52-15.26,11,4.25,170.58,107.78,2.06-.47-171.76L225,296.42l-4.73-9.36-26.82,20Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.72,506.16l2.6,0,167.85,3.21,7.34-186.64s-14.91-6.57-25-5.51c0,0-21-14.19-28.55-14.34s-19.77-15.41-19.77-15.41-.6,31.33-9.81,53.71-16.83,93.71-16.83,93.71l-37.84-117.3v-32a57.21,57.21,0,0,0-9.66,13c-3.91,7.44-16.6,16-16.6,16s-34.22,19.41-40.54,21.8-8.9,4.83-8.9,4.83l3.38,30.58,1.93,17.31Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.64,433.54c1.06,10-3.55,53.84-3.55,53.84l-1.84,3.16-1.79,3.07L74.06,345.84a7,7,0,0,1,2-2.32,17.13,17.13,0,0,1,4-2.25l5,.09S118.58,423.48,119.64,433.54Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.54,457.16s12.19-47.4,32.14-42-.77,40.1-.77,40.1Z",
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.27,459.47s-47.6-2.17-47.67,1.59-6.79,27.45-3,27.52,32.6-.63,32.58.63,15,4.05,15,4.05Z",
    style: {
      fill: "#ffb8b8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "186.06 500.01 184.13 510.3 117.85 509.39 115.72 506.18 110.67 486.73 113.34 487.04 116.09 487.38 186.06 500.01",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.06,459.73s-16.25-2.82-16.27-1.56-10.78,39.91-5.78,40,23.74,4.22,23.74,4.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.74,322.62l8.77.17s5,.1,7.38,7.66,18,41.72,15.45,44.18-3.79,1.18-1.33,3.73,3.74,1.33,2.44,3.81,11.23,67.91,3.23,92.83-9.47,36.16-14.48,36.08l-129.93-2.49s-7-49-2-50.18,91.6-4.51,91.6-4.51S265.92,323.52,284.74,322.62Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.13,189.53l-9-3.46s19.25-18.53,45.51-16.38l-7.22-7.53s18.19-6.22,34.29,11.34c8.46,9.24,18.25,20.09,24.25,32.21l9.68.19-4.2,8,14,8.35L240,220.52a40.79,40.79,0,0,1-1.77,20.89l-3.46,9s-12.64-26.54-12.58-29.83L222,228.8s-8.9-7.57-8.8-12.5l-5,5.66-2.29-9.09-30.57,8.46,5.07-7.3-18.94,2.1,7.57-8.89s-21.56,10.27-22.56,19.29-11.89,20.31-11.89,20.31l-4.77-8.31S123.07,201.4,147.13,189.53Z",
    style: {
      fill: "#2f2e41"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.17,346.17l28,86.62c10-16.72,36.32-26.87,59.61-14,15.25-16.72,42.9-15.62,55-4.17,35.23-18.23,61.45-9.25,73.9,29.31l6.54,20.27c13.07,40.47-7.44,79.14-2.35,118.22A10,10,0,0,1,462,593.22l-81.47,26.3L338.67,633,310,642.29A10,10,0,0,1,298.42,638c-11.64-18.59-32.05-28.53-52.15-37.21-15.5-6.84-30.75-12.9-47.4-17.06-26.71-6.6-61.42-7.64-64.12-16-7.18-22.25-5.14-44.58,20-52.69,24.27-7.84,44.15.31,59.52,3.37a10,10,0,0,0,11.38-12.9L181.18,367.8c-5.66-17.54,4.89-38.57,22.68-44.32C221.92,317.66,242.34,328.11,248.17,346.17Z",
    style: {
      fill: "#ffb8b8",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 4
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClick);
export default __webpack_public_path__ + "static/media/click.fdd72ab6ba42910a9a6108af8bac606e.svg";
export { ForwardRef as ReactComponent };